import { type FC } from "react";
import styled from "styled-components";
import { CustomerApiType } from "../../../../util/types";
import { DetailCardsGrid } from "../../components/detail-cards";
import { ConfigurableDetailCards } from "../../components/detail-cards/config-detail-card";
import { buildCustomerDetailsCardsConfig } from "../config/detailsCardConfig";

interface CustomerDetailsProps {
  data: CustomerApiType;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

const CustomerDetails: FC<CustomerDetailsProps> = ({ data }) => {
  const cardsConfig = buildCustomerDetailsCardsConfig(data);

  return (
    <Container>
      <DetailCardsGrid>
        <ConfigurableDetailCards config={cardsConfig} data={data} />
      </DetailCardsGrid>
    </Container>
  );
};

export default CustomerDetails;
